import AddressFromToCell from '@/components/Reports/Cell/AddressFromToCell.vue'

const config = {
  cellRenderer: AddressFromToCell
}
export default {
  type: 'AddressFromTo',
  config
}
